'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _dashboard = require('./dashboard.component');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _dashboard3 = require('./dashboard.config');

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('dashboard', [_angularUiRouter2.default]).component('dashboard', _dashboard2.default).config(_dashboard3.DashboardConfig).name;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/dashboard/index.js
 **/